/**
 * Created by asiulik on 19.01.2018.
 */

define(['lodash', 'eventEmitter/EventEmitter'], function(_, EventEmitter){

    function Store() {
    }

    Store.prototype = _.clone(EventEmitter.prototype);

    Store.prototype.init = function(){
        this.store = this.getStoreFromStorage();
    };

    Store.prototype.getStoreFromStorage = function(){
        return window.localStorage;
    };

    Store.prototype.getStoreValue = function(storeName){
        return this.store[storeName];
    };

    Store.prototype.setStoreValue = function(storeName, value){
        window.localStorage.setItem(storeName, value)
    };

    return Store;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/store/store.js